import { ReportProcess } from '@/models/ReportProcess';
import { RequestAsyncReportData } from '@/models/RequestAsyncReportData';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { ReportTypes } from './types';

export const generateAsyncReportRequest = (requestAsyncReportData: RequestAsyncReportData) =>
    action(ReportTypes.GENERATE_ASYNC_REPORT_REQUEST, requestAsyncReportData);
export const generateAsyncReportSuccess = (reportId: number) => action(ReportTypes.GENERATE_ASYNC_REPORT_SUCCESS, reportId);
export const generateAsyncReportFailure = (error: AxiosError, reportId: number) =>
    action(ReportTypes.GENERATE_ASYNC_REPORT_FAILURE, { error, reportId });

export const listReportProcessesRequest = (reportId: number) => action(ReportTypes.LIST_REPORT_PROCESSES_REQUEST, reportId);
export const listReportProcessesSuccess = (reportId: number, reportProcesses: ReportProcess[]) =>
    action(ReportTypes.LIST_REPORT_PROCESSES_SUCCESS, { reportId, reportProcesses });
export const listReportProcessesFailure = (error: AxiosError) => action(ReportTypes.LIST_REPORT_PROCESSES_FAILURE, error);

export const generateAsyncReportClear = () => action(ReportTypes.GENERATE_ASYNC_REPORT_CLEAR);

export const downloadLastReportRequest = (reportId: number) => action(ReportTypes.DOWNLOAD_LAST_REPORT_REQUEST, reportId);
export const downloadLastReportSuccess = () => action(ReportTypes.DOWNLOAD_LAST_REPORT_SUCCESS);
export const downloadLastReportFailure = (error: AxiosError) => action(ReportTypes.DOWNLOAD_LAST_REPORT_FAILURE, error);
